import { QueryClient } from '@tanstack/react-query'
import { fetchPage } from '@vangst/services/oogst/page'
import { RobotsEnum, SignUpContextEnum } from '@vangst/services/oogst/types'
import Routes from '@vangst/services/routes'
import { InferGetStaticPropsType } from 'next'
import Breadcrumbs from '../../components/navigation/Breadcrumbs'
import ClickyBtn from '../../components/navigation/ClickyBtn'
import PageHeader from '../../components/views/PageHeader'
import Meta from '../../domains/application/Meta'
import SignUpForm from '../../domains/viewer/SignUpFormCompany'

export async function getStaticProps() {
  const queryClient = new QueryClient()
  const rawUrl = __filename.split('pages')[1]?.replace('.js', '')
  const { getPage } = await fetchPage(queryClient, { rawUrl })
  const page = {
    ...getPage,
    title: getPage?.title ?? 'Company Registration',
    subtitle:
      getPage?.subtitle ??
      'Are you a cannabis business looking to hire? Register a free Vangst business account to get access to the largest network of cannabis pros in the industry.',
  }
  const crumbs = [
    { href: Routes.INDEX, text: 'Home' },
    { href: null, text: 'Company Sign Up' },
  ]

  return {
    props: { crumbs, page },
    revalidate: 30,
  }
}

// -------------------------------------

type PropsType = InferGetStaticPropsType<typeof getStaticProps>

export default function SignUpPage(props: PropsType) {
  const { crumbs, page } = props

  return (
    <>
      <Meta
        key="meta"
        canonicalUrl={page.metaInfo?.canonicalUrl}
        crumbs={crumbs}
        description={page.metaInfo?.description}
        image={page.pagePhotos?.[0]?.url}
        publishDate={page.postedAt}
        robots={page.metaInfo?.robots ?? RobotsEnum.IndexFollow}
        title={page.metaInfo?.title ?? page?.title}
      />
      <Breadcrumbs crumbs={crumbs} />
      <article className="mood-white">
        <PageHeader
          accent="text-white"
          className="bg-blue text-white"
          icon="business"
          title={page.title}
          subtitle={page.subtitle}
          description={page.description}
          imgAlt={page.pagePhotos?.[0]?.alt}
          imgSrc={page.pagePhotos?.[0]?.url}
        />
        <div className="contain-c template-content-aside">
          <section className="contain-xy flex max-w-prose flex-col gap-8 md:ml-24">
            <SignUpForm as="page" from={SignUpContextEnum.CompanySignUpForm} />
          </section>
          <aside className="contain-xy flow-y-sm mood-white sm:gap-8">
            <h2 className="heading-sm">Need a Candidate account?</h2>
            <p>
              Looking for a job in cannabis? the cannabis industry’s #1 job
              platform today to start your cannabis career journey.
            </p>
            <ClickyBtn
              as="text-icon"
              className="mood-orange max-w-72"
              href={Routes.SIGN_UP}
            >
              Candidate Sign Up
            </ClickyBtn>
          </aside>
        </div>
      </article>
    </>
  )
}
